import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PageHeader from '../Layout/PageHeader';
import '../../styles/ContactUs.css';

const WEB3FORMS_ACCESS_KEY = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;

const ContactUs = () => {
  const [searchParams] = useSearchParams();
  const serviceFromUrl = searchParams.get('service');
  const [showPopup, setShowPopup] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailPattern.test(email);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitError('');

    const email = event.target.email.value;

    if (!validateEmail(email)) {
      setEmailError('Please enter a valid email address.');
      return;
    }

    if (!WEB3FORMS_ACCESS_KEY) {
      setSubmitError('Contact form is not configured. Please email us directly.');
      return;
    }

    setEmailError('');
    setIsSubmitting(true);

    const formData = new FormData(event.target);
    formData.append('access_key', WEB3FORMS_ACCESS_KEY);

    if (serviceFromUrl) {
      formData.append('subject', `NeoApps inquiry: ${serviceFromUrl}`);
    }

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: json,
      });

      const result = await response.json();

      if (result.success) {
        setShowPopup(true);
        event.target.reset();
      } else {
        setSubmitError(result.message || 'Something went wrong. Please try again.');
      }
    } catch {
      setSubmitError('Unable to send your message right now. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="page">
      <div className="page__inner">
        <PageHeader
          label="Contact"
          title="Let's build something together"
          description={
            serviceFromUrl
              ? `Interested in ${serviceFromUrl}? Tell us about your project and we'll get back to you shortly.`
              : "Have a project in mind? Send us a message and we'll respond within 1–2 business days."
          }
        />

        <div className="surface-card form-card">
          <div className="form-info">
            <p><strong>Email:</strong> <a href="mailto:info@neoappslab.com">info@neoappslab.com</a></p>
            <p><strong>Location:</strong> Niš, Serbia</p>
          </div>

          <form onSubmit={onSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input type="text" id="name" name="name" required disabled={isSubmitting} />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" required disabled={isSubmitting} />
              {emailError && <span className="error-message">{emailError}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" rows="5" required disabled={isSubmitting}></textarea>
            </div>
            {submitError && <p className="submit-error">{submitError}</p>}
            <button type="submit" className="form-submit" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send message'}
            </button>
          </form>
        </div>

        {showPopup && (
          <div className="contact-us__popup" onClick={() => setShowPopup(false)}>
            <div className="contact-us__popup-card" onClick={(e) => e.stopPropagation()}>
              <p>Your message has been successfully sent!</p>
              <button type="button" onClick={() => setShowPopup(false)}>Close</button>
            </div>
          </div>
        )}
      </div>
    </main>
  );
};

export default ContactUs;
